import Faded from '../music/Faded.mp3'
import Alone from '../music/Alone.mp3'
import Spectre from '../music/Spectre.mp3'
import Careless from '../music/Careless.mp3'
import Cold from '../music/Cold.mp3'
import Destiny from '../music/Destiny.mp3'

export const PLAYLIST = [
	{
		index: "0",
		type: "album",
		title: "Neffex",
		link: "neffex",
		imgUrl:
			"https://play-lh.googleusercontent.com/cUVOhnhFvcqMiEJ_2jz2s0pHL5mOJGojQEOby7H9v6MNPIDslfz7e_SBxGlUwLkz-2A",
		hoverColor: "rgb(224, 112, 16)",
		artist: "Workout",
		playlistBg: "rgb(224, 112, 16)",
		playlistData: [
			{
				index: "1",
				songName: "Careless",
				songimg:
					"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj5jvMFuP0PY3ySomz1rgUrRQP-LRm8lF0XQ&usqp=CAU",
				songArtist: "Neffex",
				link:
					`${Careless}`,
				trackTime: "4:57",
			},
			{
				index: "2",
				songName: "Cold",
				songimg:
					"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj5jvMFuP0PY3ySomz1rgUrRQP-LRm8lF0XQ&usqp=CAU",
				songArtist: "Neffex",
				link:
					`${Cold}`,
				trackTime: "3:06",
			},
			{
				index: "3",
				songName: "Destiny",
				songimg:
					"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj5jvMFuP0PY3ySomz1rgUrRQP-LRm8lF0XQ&usqp=CAU",
				songArtist: "Neffex",
				link:
					`${Destiny}`,
				trackTime: "3:27",
			},
		],
	},
	{
		index: "1",
		type: "playlist",
		title: "Alan Walker",
		link: "alanwalker",
		imgUrl:
			"https://source.boomplaymusic.com/group10/M00/06/17/af4a403ceddf4bec922a7f52ef0e16c0_464_464.webp",
		hoverColor: "rgb(216, 24, 40)",
		artist: "Alan Walker",
		playlistBg: "rgb(216, 24, 40)",
		playlistData: [
			{
				index: "1",
				songName: "Faded",
				songimg:
					"https://slm-assets.secondlife.com/assets/21562313/lightbox/alam-walker-faded-song-lyrics-750750.jpg?1536637778",
				songArtist: "Eletronic",
				link:
					`${Faded}`,
				trackTime: "3:33",
			},
			{
				index: "2",
				songName: "Alone",
				songimg:
					"https://i1.sndcdn.com/artworks-000221483203-mmrr8c-t500x500.jpg",
				songArtist: "Eletronic",
				link:
					`${Alone}`,
				trackTime: "2:43",
			},
			{
				index: "3",
				songName: "Spectre",
				songimg:
					"https://i1.sndcdn.com/artworks-ZdCS11kNeiyAAVf9-zuTrOA-t500x500.jpg",
				songArtist: "Eletronic",
				link:
					`${Spectre}`,
				trackTime: "3:26",
			},
		],
	},
	{
		index: "2",
		type: "playlist",
		title: "Daily Mix 1",
		link: "dailymix1",
		imgUrl:
			"https://dailymix-images.scdn.co/v2/img/ab67616d0000b2731cfa3aa970ec68a11a015c7c/1/tr/default",
		hoverColor: "rgb(192, 32, 40)",
		artist: "Murder King, Black Tooth",
		playlistBg: "rgb(136, 8, 24)",
		playlistData: [
			{
				index: "1",
				songName: "Fiasco",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851088ed5ba2a9d32608d8942f2",
				songArtist: "Murder King",
				link:
					"https://p.scdn.co/mp3-preview/2680aa5c61fede26f4cc24edfa17f7b18edfac38?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "2",
				songName: "Arıza",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851cc462180ef86e33de2265441",
				songArtist: "Malt",
				link:
					"https://p.scdn.co/mp3-preview/95f66bb0428213025201b6139a9400e7bd2f6050?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "3",
				songName: "Yukarıya Bak",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851e0cfce61b45ba6064a07fb0e",
				songArtist: "Ogün Sanlısoy",
				link:
					"https://p.scdn.co/mp3-preview/182320dad925b62fe2dc6332213efd886de06389?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
		],
	},
	{
		index: "3",
		type: "playlist",
		title: "mix pop",
		link: "mixpop",
		imgUrl:
			"https://daily-mix.scdn.co/covers/backtracks/PZN_Repeat_Rewind2_LARGE-tr.jpg",
		hoverColor: "rgb(240, 56, 168)",
		artist: "pop",
		playlistBg: "rgb(240, 56, 168)",
		playlistData: [
			{
				index: "1",
				songName: "Irıe",
				songimg:
					"https://i.scdn.co/image/ab67616d000048515ac8e878a5af6bebbcd83cd8",
				songArtist: "Sattas",
				link:
					"https://p.scdn.co/mp3-preview/8b54586a78acbc69fb19bdcd3cb47914b3d3971b?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "2",
				songName: "I Shot The Sheriff",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851d752956b8a82ffa07baa835e",
				songArtist: "Eric Clapton",
				link:
					"https://p.scdn.co/mp3-preview/1d3fc3dcc454fb4cab86f183e468617a21c3bfdd?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "3",
				songName: "Before You Accuse Me",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851ed4b2a6ea7d8a04f39be0be0",
				songArtist: "Eric Clapton",
				link:
					"https://p.scdn.co/mp3-preview/52cba5b168dae7b1d8e30d3873fc709fc2012a5f?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
		],
	},
	{
		index: "4",
		type: "playlist",
		title: "Daily Mix 2",
		link: "dailymix2",
		imgUrl:
			"https://dailymix-images.scdn.co/v2/img/04cd9bccf59e8061f13e779d1001975a60fb837a/2/tr/default",
		hoverColor: "rgb(136, 152, 152)",
		artist:
			"Arch green",
		playlistBg: "rgb(136, 152, 152)",
		playlistData: [
			{
				index: "1",
				songName: "The World Is Yours",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851f22accdfcf008be55b063aae",
				songArtist: "Arch Enemy",
				link:
					"https://p.scdn.co/mp3-preview/f8bef3ca1ebf7c7b72cb61e6a35053f801fa66d9?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "2",
				songName: "Cocaine",
				songimg:
					"https://i.scdn.co/image/ab67616d000048515e7464d9d8a25b2bf74b782a",
				songArtist: "Eric Clapton",
				link:
					"https://p.scdn.co/mp3-preview/4272f788ea24f7dd3ce9a5ed8bb5dcf125f88844?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "3",
				songName: "Nemesis",
				songimg:
					"https://i.scdn.co/image/ab67616d00004851dcbd25c605dddb32022cecba",
				songArtist: "Arch Enemy",
				link:
					"https://p.scdn.co/mp3-preview/2591d93eec734f134accdda26634738069dc7238?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
		],
	},
	{
		index: "5",
		type: "playlist",
		title: "Daily Mix 3",
		link: "dailymix3",
		imgUrl:
			"https://dailymix-images.scdn.co/v2/img/c23701238e46876969ea3b694e9b42b8db133b91/3/tr/default",
		hoverColor: "rgb(83, 83, 83)",
		artist: "Amaranthe, Metalite",
		playlistBg: "rgb(83, 83, 83)",
		playlistData: [
			{
				index: "1",
				songName: "See You In Hell",
				songimg:
					"https://i.scdn.co/image/ab67616d000048515ef2b5cf848e8cf0e656d10b",
				songArtist: "Ad Infinitum",
				link:
					"https://p.scdn.co/mp3-preview/b8d5cbcfc074be8f58c88f0fa0604ab9986c49b5?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "2",
				songName: "Demons",
				songimg:
					"https://i.scdn.co/image/ab67616d000048515ef2b5cf848e8cf0e656d10b",
				songArtist: "Ad Infinitum",
				link:
					"https://p.scdn.co/mp3-preview/8f66d19e71277f3ecdca11f851b5a588b47802d4?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
			{
				index: "3",
				songName: "Digital World",
				songimg:
					"https://i.scdn.co/image/ab67616d000048517e1fea351d3673f4f94f5c8c",
				songArtist: "Amaranthe",
				link:
					"https://p.scdn.co/mp3-preview/466e3e1522dbeb23d6876bb84a0d60ce77bd0ed6?cid=6d083ea30aaa46428fbf1590d31f6750",
				trackTime: "0:30",
			},
		],
	},
	{
		index: "6",
		type: "podcast",
		title: "podcast",
		link: "otarzmi",
		imgUrl:
			"https://i.scdn.co/image/dacd32a7203aeb7b7910d8880943a939c8006b0a",
		hoverColor: "rgb(83, 83, 83)",
		artist: "otarzmi",
		playlistBg: "rgb(83, 83, 83)",
		playlistData: [
			{
				index: "1",
				songName: "S06E36- episode",
				songimg:
					"https://i.scdn.co/image/dacd32a7203aeb7b7910d8880943a939c8006b0a",
				songArtist: "otarzmi",
				link: "https://episodes.buzzsprout.com/gozvh84ncp95hmvgapex1dk5pjwx?",
				trackTime: "41:25",
			},
		],
	},
];

export const MUSICLINKS = [
	{
		link:
			"https://server1.indiryuklemp3.org/mp3_files/yalan-t3OjaAeo6z-0.mp3",
	},
	{
		link:
			"https://server1.indiryuklemp3.org/mp3_files/a9b438cef5490afe36b0d0cb18ba9385.mp3",
	},
	{
		link:
			"https://server1.indiryuklemp3.org/mp3_files/a9b438cef5490afe36b0d0cb18ba9385.mp3",
	},
	{
		link:
			"https://server1.indiryuklemp3.org/mp3_files/a9b438cef5490afe36b0d0cb18ba9385.mp3",
	},
];

export const SEARCHCARDS = [
	{
		bgcolor: 'rgb(75, 145, 125)',
		imgurl: 'https://t.scdn.co/images/4b7472015a274eadbc00119f5141e548.jpeg',
		title: 'Samba',
	},
	{
		bgcolor: 'rgb(111, 111, 111)',
		imgurl: 'https://t.scdn.co/images/ffbc60a80ba64554ac09130827c43d06.jpeg',
		title: 'Metal',
	},
	{
		bgcolor: 'rgb(235, 30, 50)',
		imgurl: 'https://t.scdn.co/images/31c85ae6fec34a16927ef28a7a88e97b.jpeg',
		title: 'Rock',
	},
	{
		bgcolor: 'rgb(195, 240, 200)',
		imgurl: 'https://t.scdn.co/images/d355f48a90b64c25b6e004179a596e51.jpeg',
		title: 'Pop',
	},
	{
		bgcolor: 'rgb(160, 195, 210)',
		imgurl: 'https://t.scdn.co/images/0f2f4c71c9714cc5b757f7bb3559fcdb.jpeg',
		title: 'Jazz',
	},
	{
		bgcolor: 'rgb(245, 155, 35)',
		imgurl: 'https://t.scdn.co/images/9676cef74ec147a48607c737c4f93943.jpeg',
		title: 'Hip Hop',
	},
	{
		bgcolor: 'rgb(245, 155, 35)',
		imgurl: 'https://t.scdn.co/images/ad4d5c268a214f78920517e76e6ed107.jpeg',
		title: 'Podcast',
	},
	{
		bgcolor: 'rgb(255, 100, 55)',
		imgurl: 'https://t.scdn.co/images/60075fbc12304968941c7445a971fb9d.jpeg',
		title: 'Concerts',
	},
	{
		bgcolor: 'rgb(80, 155, 245)',
		imgurl: 'https://t.scdn.co/images/baf681efc57145e180589e027496b101.jpeg',
		title: 'MPB',
	},
	{
		bgcolor: 'rgb(245, 155, 35)',
		imgurl: 'https://t.scdn.co/images/194b9d722de34cefb3b716c653b4526b.png',
		title: 'Synthwave',
	},
	{
		bgcolor: 'rgb(160, 195, 210)',
		imgurl: 'https://t.scdn.co/images/2470fe22d03a4375a9501dce8cfb2b8c.jpeg',
		title: 'Chill',
	},
	{
		bgcolor: 'rgb(180, 155, 200)',
		imgurl: 'https://t.scdn.co/images/cf23ab0343e047daa88703e21c01a4aa.jpeg',
		title: 'Eletronic',
	}
]
